import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BlFrontendButtonComponent } from '@app/core/wrappers/bl-frontend-button.component';
import { TranslocoModule } from '@jsverse/transloco';
import { DialogService, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { getTranslationProvider } from 'src/app/core/i18n/getTranslationProvider';
import { TranslatableFormDialogBaseComponent } from 'src/app/core/i18n/translatable-form-dialog-base.component';
import { DialogData, DialogResult } from '../../form-dialog-base/form-dialog-base.component';
import { PleaseWaitComponent } from '../../please-wait/please-wait.component';

interface Result extends DialogResult {
  confirmed: boolean;
}

const TRANSLATION_SCOPE = 'corporateIdentityExistsDialog';

@Component({
  selector: 'app-corporate-identity-exists-dialog',
  template: `
    <div *transloco="let t; prefix: scope">
      <p>{{ t('orgNumberAlreadyExistsText') }}</p>
      <div class="flex justify-end mt-4 space-x-2">
        <bl-frontend-button
          [text]="'shared.cancel' | transloco"
          variant="secondary"
          (onclick)="close({ confirmed: false })" />
        <bl-frontend-button [text]="'shared.save' | transloco" (onclick)="close({ confirmed: true })" />
      </div>
    </div>
  `,
  standalone: true,
  providers: [DialogService, getTranslationProvider(TRANSLATION_SCOPE)],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BlFrontendButtonComponent,
    PleaseWaitComponent,
    TranslocoModule,
  ],
})
export class CorporateIdentityExistsDialog extends TranslatableFormDialogBaseComponent<DialogData, Result> {
  protected static override getTranslationScope(): string {
    return TRANSLATION_SCOPE;
  }

  protected static override getDialogConfig(
    translation: Record<string, string>,
  ): Omit<DynamicDialogConfig<DialogData>, 'data'> {
    return {
      header: translation.orgNumberAlreadyExists,
      draggable: false,
      modal: true,
    };
  }
}
